import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import ExternalOrders from '../../../components/external/orders/order/order.component';


class OrderRootLayout extends Component {

    render() {
        return (
            <>
                <BrowserRouter>
                    <Switch>
                        <Route exact path="/external/Orders/Orders" render={props => (
                        <ExternalOrders />
                        )}>
                        </Route>
                    </Switch>
                </BrowserRouter>
            </>
        );
    }
}



export default OrderRootLayout;